<template>
  <div id="page-user-view">
    <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.id }} not found.</span>
      <span>
        <span>Check</span>
        <router-link :to="{ name: 'system-user-list' }" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <div id="user-data" v-if="user_data">
      <vx-card :title="$t('users.account')" class="mb-base">
        <div class="vx-row">
          <div class="vx-col" id="avatar-col">
            <div class="img-container mb-4">
              <vs-avatar :src="avatar" size="80px" class="mr-4" />
            </div>
          </div>

          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">{{ $t('users.username') }}</td>
                <td>{{ user_data.username }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t('users.first_name') }}</td>
                <td>{{ user_data.details.firstName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t('users.last_name') }}</td>
                <td>{{ user_data.details.lastName }}</td>
              </tr>
            </table>
          </div>

          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-semibold">{{ $t('entity.state') }}</td>
                <td>{{ $t('entity.states.' + user_data.state) }}</td>
              </tr>
            </table>
          </div>

          <div class="vx-col w-full flex" id="account-manage-buttons">
            <vs-button
              icon-pack="feather"
              icon="icon-edit"
              class="mr-4"
              :to="{ name: 'system-user-edit', params: { Id: $route.params.id } }"
              >{{ $t('button.edit') }}</vs-button
            >
            <vs-button
              type="border"
              color="danger"
              icon-pack="feather"
              icon="icon-trash"
              class="mr-4"
              @click="confirmDeleteRecord"
              >{{ $t('button.delete') }}</vs-button
            >
            <vs-button type="border" color="warning" icon-pack="feather" @click="loginAsUser">{{
              $t('button.login_as_user')
            }}</vs-button>
          </div>
        </div>
      </vx-card>

      <div class="vx-row">
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card :title="$t('users.information')" class="mb-base">
            <table>
              <tr>
                <td class="font-semibold">{{ $t('users.birthday') }}</td>
                <td>{{ user_data.details.birthday }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t('users.genders.gender') }}</td>
                <td>{{ user_data.details.gender }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t('users.address') }}</td>
                <td>{{ user_data.address }}</td>
              </tr>
            </table>
          </vx-card>
        </div>

        <div class="vx-col lg:w-1/2 w-full">
          <vx-card :title="$t('entity.roles_and_groups')" class="mb-base">
            <table>
              <tr v-if="user_data.roles">
                <td class="font-semibold">{{ $t('entity.roles') }}</td>
                <td>{{ user_data.roles.join(', ') }}</td>
              </tr>
              <tr v-if="user_data.groups">
                <td class="font-semibold">{{ $t('entity.groups') }}</td>
                <td>{{ user_data.groups.join(', ') }}</td>
              </tr>
              <tr v-if="user_data.tags">
                <td class="font-semibold">{{ $t('entity.tags') }}</td>
                <td>{{ user_data.tags.join(', ') }}</td>
              </tr>
              <tr v-if="user_data.partners">
                <td class="font-semibold">{{ $t('entity.partners') }}</td>
                <td>{{ user_data.partners.join(', ') }}</td>
              </tr>
            </table>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'

export default {
  data() {
    return {
      user_data: null,
      user_not_found: false,
      avatar: null
    }
  },
  computed: {
    userAddress() {
      let str = ''
      for (const field in this.user_data.location) {
        str += `${field} `
      }
      return str
    }
  },
  methods: {
    confirmDeleteRecord() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('forms.are_you_sure'),
        text: this.$t('forms.confirm_delete', {
          title: `${this.$t('users.account')} "${this.user_data.username}"`
        }),
        accept: this.deleteRecord,
        acceptText: this.$t('forms.delete'),
        cancelText: this.$t('forms.cancel')
      })
    },
    deleteRecord() {
      this.$store.dispatch('userManagement/removeUser', this.user_data.id).then(() => {
        this.showDeleteSuccess()
        this.$router.push({ name: 'system-user-list' })
      })
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: 'success',
        title: this.$t('forms.successfully_deleted')
      })
    },
    loginAsUser() {
      this.$store.dispatch('auth/loginAsUser', this.user_data.id).then(res => {
        this.$acl.change(res.data.userData.roles)
        this.$router.push({ name: 'dashboard' })
        window.location = '/'
      })
    }
  },
  created() {
    // Register Module UserManagement Module
    if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }

    const userId = this.$route.params.id
    this.$store
      .dispatch('userManagement/fetchUser', userId)
      .then(res => {
        this.user_data = res.data
        //get avatar
        if (this.user_data.avatar) {
          this.$store.dispatch('file/downloadFile', this.user_data.avatar).then(response => {
            this.avatar = response
          })
        }
      })
      .catch(err => {
        if (err.response.status === 404) {
          this.user_not_found = true
        }
      })
  }
}
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}

@media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }
}
</style>
